var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M9.625 8.167h.006m.286 0a.292.292 0 1 1-.584 0 .292.292 0 0 1 .584 0",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.4,
    d: "M1.75 2.917v8.166c0 .645.522 1.167 1.167 1.167h8.166c.645 0 1.167-.522 1.167-1.167V5.25c0-.644-.522-1.167-1.167-1.167H2.917A1.167 1.167 0 0 1 1.75 2.917m0 0c0-.645.522-1.167 1.167-1.167h7"
  }))));
};
export default SvgWallet;